import React, { useState, useRef } from 'react';
import { Typography, TextField, Button } from '@material-ui/core/';
import { useDispatch } from 'react-redux';
import DeleteIcon from '@material-ui/icons/Delete';

import { commentDelete, commentPost } from '../../actions/posts';
import useStyles from './styles';
import moment from 'moment';

const CommentSection = ({ post }) => {
  const user = JSON.parse(localStorage.getItem('profile'));
  const [comment, setComment] = useState('');
  const dispatch = useDispatch();
  const [comments, setComments] = useState(post?.comments);
  const classes = useStyles();
  const commentsRef = useRef();

  const handleComment = async () => {
    const newComments = await dispatch(commentPost({author: user.result._id, comment}, post._id));

    setComment('');
    setComments(newComments);

    commentsRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <div className={classes.commentsOuterContainer}>
        <div 
        // style={{ width: '40%' }}
         className={classes.commentsInnerContainer}>
          <Typography gutterBottom variant="h6">Comments</Typography>
          {comments?.map((c, i) => (
            <>
            {/* {(user?.result?._id === c?.author?._id) && (
          <Button size="small" color="secondary" onClick={() => dispatch(commentDelete(c?._id, post?._id))}>
            <DeleteIcon fontSize="small" /> &nbsp; Delete
          </Button>
        )} */}
            <Typography key={i} gutterBottom variant="subtitle1">
              <strong>{c?.author?.name}</strong>{" "}
              {moment(c?.createdAt).fromNow()}
            </Typography>
            <Typography key={i} gutterBottom variant="subtitle1">
              {c?.comment}
            </Typography>
            </>
          ))}
          <div ref={commentsRef} />
        </div>
        <div 
        // style={{ width: '60%' }}
         className={classes.commentsInputContainer}>
          <Typography gutterBottom variant="h6">Write a comment</Typography>
          <TextField inputProps={{ maxLength: 255 }} fullWidth rows={4} variant="outlined" label="Comment" multiline value={comment} onChange={(e) => setComment(e.target.value)} />
          <br />
          <Button style={{ marginTop: '10px' }} fullWidth disabled={!comment.length} color="primary" variant="contained" onClick={handleComment}>
            Comment
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CommentSection;
